import { render } from "./ModalUserInviteCancel.vue?vue&type=template&id=2ec56e78&scoped=true"
import script from "./ModalUserInviteCancel.vue?vue&type=script&lang=js"
export * from "./ModalUserInviteCancel.vue?vue&type=script&lang=js"

import "./ModalUserInviteCancel.vue?vue&type=style&index=0&id=2ec56e78&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec56e78"]])

export default __exports__